// extracted by mini-css-extract-plugin
export default {"table":"DataTable_table__FcpW3","loader":"DataTable_loader__FyD2F"};